import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const EN2418Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "EN2418IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <g clipPath="url(#clip0_1813_596)">
        <rect width="24" height="18" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H24V18H0V0Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 11V12.5H24V11H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 13.75V15.25H24V13.75H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 5.5V7H24V5.5H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 16.5V18H24V16.5H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 8.25V9.75H24V8.25H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V1.5H24V0H0Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2.75V4.25H24V2.75H0Z"
          fill="#E31D1C"
        />
        <rect width="15" height="9.75" fill="#2E42A5" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.29143 2.20415L0.74702 2.58582L0.930818 1.90661L0.447281 1.47618H1.07885L1.29067 0.921875L1.53905 1.47618H2.07744L1.65441 1.90661L1.81818 2.58582L1.29143 2.20415ZM4.29141 2.20415L3.747 2.58582L3.9308 1.90661L3.44727 1.47618H4.07883L4.29065 0.921875L4.53903 1.47618H5.07742L4.6544 1.90661L4.81817 2.58582L4.29141 2.20415ZM6.747 2.58582L7.29141 2.20415L7.81817 2.58582L7.6544 1.90661L8.07742 1.47618H7.53903L7.29065 0.921875L7.07883 1.47618H6.44727L6.9308 1.90661L6.747 2.58582ZM10.2914 2.20415L9.747 2.58582L9.9308 1.90661L9.44727 1.47618H10.0788L10.2907 0.921875L10.539 1.47618H11.0774L10.6544 1.90661L10.8182 2.58582L10.2914 2.20415ZM0.747004 5.58582L1.29141 5.20415L1.81817 5.58582L1.6544 4.90661L2.07742 4.47618H1.53903L1.29065 3.92188L1.07883 4.47618H0.447266L0.930803 4.90661L0.747004 5.58582ZM4.29141 5.20415L3.747 5.58582L3.9308 4.90661L3.44727 4.47618H4.07883L4.29065 3.92188L4.53903 4.47618H5.07742L4.6544 4.90661L4.81817 5.58582L4.29141 5.20415ZM6.747 5.58582L7.29141 5.20415L7.81817 5.58582L7.6544 4.90661L8.07742 4.47618H7.53903L7.29065 3.92188L7.07883 4.47618H6.44727L6.9308 4.90661L6.747 5.58582ZM10.2914 5.20415L9.747 5.58582L9.9308 4.90661L9.44727 4.47618H10.0788L10.2907 3.92188L10.539 4.47618H11.0774L10.6544 4.90661L10.8182 5.58582L10.2914 5.20415ZM0.747004 8.58582L1.29141 8.20415L1.81817 8.58582L1.6544 7.90661L2.07742 7.47618H1.53903L1.29065 6.92188L1.07883 7.47618H0.447266L0.930803 7.90661L0.747004 8.58582ZM4.29141 8.20415L3.747 8.58582L3.9308 7.90661L3.44727 7.47618H4.07883L4.29065 6.92188L4.53903 7.47618H5.07742L4.6544 7.90661L4.81817 8.58582L4.29141 8.20415ZM6.747 8.58582L7.29141 8.20415L7.81817 8.58582L7.6544 7.90661L8.07742 7.47618H7.53903L7.29065 6.92188L7.07883 7.47618H6.44727L6.9308 7.90661L6.747 8.58582ZM10.2914 8.20415L9.747 8.58582L9.9308 7.90661L9.44727 7.47618H10.0788L10.2907 6.92188L10.539 7.47618H11.0774L10.6544 7.90661L10.8182 8.58582L10.2914 8.20415ZM12.747 2.58582L13.2914 2.20415L13.8182 2.58582L13.6544 1.90661L14.0774 1.47618H13.539L13.2907 0.921875L13.0788 1.47618H12.4473L12.9308 1.90661L12.747 2.58582ZM13.2914 5.20415L12.747 5.58582L12.9308 4.90661L12.4473 4.47618H13.0788L13.2907 3.92188L13.539 4.47618H14.0774L13.6544 4.90661L13.8182 5.58582L13.2914 5.20415ZM12.747 8.58582L13.2914 8.20415L13.8182 8.58582L13.6544 7.90661L14.0774 7.47618H13.539L13.2907 6.92188L13.0788 7.47618H12.4473L12.9308 7.90661L12.747 8.58582ZM2.79141 3.70415L2.247 4.08582L2.4308 3.40661L1.94727 2.97618H2.57883L2.79065 2.42188L3.03903 2.97618H3.57742L3.1544 3.40661L3.31817 4.08582L2.79141 3.70415ZM5.247 4.08582L5.79141 3.70415L6.31817 4.08582L6.1544 3.40661L6.57742 2.97618H6.03903L5.79065 2.42188L5.57883 2.97618H4.94727L5.4308 3.40661L5.247 4.08582ZM8.79141 3.70415L8.247 4.08582L8.4308 3.40661L7.94727 2.97618H8.57883L8.79065 2.42188L9.03903 2.97618H9.57742L9.1544 3.40661L9.31817 4.08582L8.79141 3.70415ZM2.247 7.08582L2.79141 6.70415L3.31817 7.08582L3.1544 6.40661L3.57742 5.97618H3.03903L2.79065 5.42188L2.57883 5.97618H1.94727L2.4308 6.40661L2.247 7.08582ZM5.79141 6.70415L5.247 7.08582L5.4308 6.40661L4.94727 5.97618H5.57883L5.79065 5.42188L6.03903 5.97618H6.57742L6.1544 6.40661L6.31817 7.08582L5.79141 6.70415ZM8.247 7.08582L8.79141 6.70415L9.31817 7.08582L9.1544 6.40661L9.57742 5.97618H9.03903L8.79065 5.42188L8.57883 5.97618H7.94727L8.4308 6.40661L8.247 7.08582ZM11.7914 3.70415L11.247 4.08582L11.4308 3.40661L10.9473 2.97618H11.5788L11.7907 2.42188L12.039 2.97618H12.5774L12.1544 3.40661L12.3182 4.08582L11.7914 3.70415ZM11.247 7.08582L11.7914 6.70415L12.3182 7.08582L12.1544 6.40661L12.5774 5.97618H12.039L11.7907 5.42188L11.5788 5.97618H10.9473L11.4308 6.40661L11.247 7.08582Z"
          fill="#F7FCFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_1813_596">
          <rect width="24" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EN2418Icon;
